/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_User_Questions_Back_LabelInputs */

const en_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const de_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const pt_br2_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const tr_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri`)
};

const zh_cn2_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const zh_hk2_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const ko_kr2_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤로`)
};

const ru_ru2_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const es_419_components_ask_user_questions_back_label = /** @type {(inputs: Components_Ask_User_Questions_Back_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrás`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Components_Ask_User_Questions_Back_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_ask_user_questions_back_label = /** @type {((inputs?: Components_Ask_User_Questions_Back_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_User_Questions_Back_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_ask_user_questions_back_label(inputs)
	if (locale === "de") return de_components_ask_user_questions_back_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_ask_user_questions_back_label(inputs)
	if (locale === "tr") return tr_components_ask_user_questions_back_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_ask_user_questions_back_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_ask_user_questions_back_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_ask_user_questions_back_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_ask_user_questions_back_label(inputs)
	return es_419_components_ask_user_questions_back_label(inputs)
});